module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-row', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '500px',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isModalCrearUsuario),
      callback: function($$v) {
        _vm.isModalCrearUsuario = $$v
      },
      expression: "isModalCrearUsuario"
    }
  }, [_c('v-card', {
    staticClass: "pa-6"
  }, [_c('h1', {
    staticClass: "h1-nuevo"
  }, [_vm._v("Nuevo usuario")]), _c('v-layout', {
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "login-form text-xs-center"
  }, [_c('v-form', [_c('v-text-field', {
    ref: "nombre",
    attrs: {
      "light": "light",
      "prepend-icon": "person",
      "label": "Nombre completo / Razon social",
      "type": "text"
    },
    on: {
      "keyup": [function (e) {
        _vm.nuevoUsuario.nombre = e.target.value.toUpperCase()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }]
    },
    model: {
      value: (_vm.nuevoUsuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "nombre", $$v)
      },
      expression: "nuevoUsuario.nombre"
    }
  }), _c('v-text-field', {
    ref: "username",
    attrs: {
      "light": "light",
      "prepend-icon": "email",
      "label": "Email (Requerido)",
      "type": "email"
    },
    on: {
      "keyup": [function (e) {
        _vm.nuevoUsuario.username = e.target.value.toLowerCase()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }]
    },
    model: {
      value: (_vm.nuevoUsuario.username),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "username", $$v)
      },
      expression: "nuevoUsuario.username"
    }
  }), _c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "loading": "loading",
      "hint": "La contraseña que usted ingrese sera encriptada para mayor seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nuevoUsuario.password),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "password", $$v)
      },
      expression: "nuevoUsuario.password"
    }
  }), _c('v-text-field', {
    ref: "password1",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": _vm.showPassword1 ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword1 ? 'text' : 'password',
      "label": "Repita la contraseña"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchRegistrar()
      }
    },
    model: {
      value: (_vm.nuevoUsuario.password1),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "password1", $$v)
      },
      expression: "nuevoUsuario.password1"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "color": "primary",
      "label": "Protección de datos personales (LEY Nº 29733)"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("¿Aceptas compartir tus datos personales?  "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.redirectProteccion()
            }
          }
        }, [_vm._v("LEY Nº 29733")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nuevoUsuario.aceptaPoliticasDePrivacidad),
      callback: function($$v) {
        _vm.$set(_vm.nuevoUsuario, "aceptaPoliticasDePrivacidad", $$v)
      },
      expression: "nuevoUsuario.aceptaPoliticasDePrivacidad"
    }
  }), _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "success",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchRegistrar()
      }
    }
  }, [_vm._v("Registrar")])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex pa-4 pb-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Busca por email, nombre",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close",
      "solo": "solo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "click:clear": function($event) {
        return _vm.fetch(true)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center"
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fetch(), _vm.fetchCountUsuarios()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), (_vm.perfilUsuario === 'sistemas') ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "success"
    },
    on: {
      "click": _vm.openDialogCrearUsuario
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition",
      "close-on-content-click": false,
      "location": "end"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "value": _vm.countFilters ? 1 : 0,
            "content": _vm.countFilters ? _vm.countFilters : 0,
            "overlap": "overlap"
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-1",
          attrs: {
            "fab": "fab"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)]
      }
    }])
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center mb-2"
  }, [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "name": "pendingActive",
      "id": "pendingActive",
      "color": "primary",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.isCuentasPendientes),
      callback: function($$v) {
        _vm.isCuentasPendientes = $$v
      },
      expression: "isCuentasPendientes"
    }
  }), _c('label', {
    staticClass: "font-size-12",
    class: {
      '!primary--text font-weight-700': _vm.isCuentasPendientes
    },
    attrs: {
      "for": "pendingActive"
    }
  }, [_vm._v("Usuarios pendientes de activación")])], 1)])], 1)], 1)], 1), _c('v-card', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "mx-auto overflow-y-auto elevation-0",
    attrs: {
      "height": "calc(100vh - 127px)",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense",
        "color": _vm.selected && (_vm.selected.usuario === item.usuario) ? 'bg-secondary primary--text' : ''
      },
      on: {
        "click": function($event) {
          return _vm.renderEditar(item)
        }
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "my-1 me-2"
    }, [_c('v-avatar', {
      attrs: {
        "color": "secondary",
        "size": "34"
      }
    }, [_c('avatar-perfil', {
      attrs: {
        "path": item.foto
      }
    })], 1)], 1), _c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      class: {
        'primary--text': (_vm.selected && _vm.selected.usuario === item.usuario)
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('small', {
      staticClass: "font-size-11 font-weight-700"
    }, [_vm._v(_vm._s(item.nombre))]), _c('div', {
      staticClass: "d-flex"
    }, [_c('small', {
      staticClass: "font-size-11 text-muted"
    }, [_vm._v(_vm._s(item.usuario))]), _c('small', {
      staticClass: "font-size-11 ml-1",
      class: {
        'blue--text': item.perfil === 'usuario-contrato', 'primary--text': item.perfil === 'usuario'
      }
    }, [_vm._v("(" + _vm._s(item.perfil) + ")")])])])])], 1), (item.perfil !== 'usuario-contrato') ? _c('v-list-item-action', [_c('v-fade-transition', {
      attrs: {
        "leave-absolute": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-icon', _vm._g(_vm._b({
            attrs: {
              "center": "",
              "size": "20",
              "color": item.emailConfirmado ? 'success' : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(item.emailConfirmado ? 'check_circle' : 'timer'))])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(item.emailConfirmado ? 'Verificado' : 'No verificado'))])])], 1)], 1) : _c('v-list-item-action', [_c('v-fade-transition', [_vm._v("(leave-absolute='')"), _c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-icon', _vm._g(_vm._b({
            attrs: {
              "center": "",
              "size": "20",
              "color": item.emailConfirmado && item.fechaCuentaActivada ? 'success' : 'background'
            }
          }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(item.emailConfirmado && item.fechaCuentaActivada ? 'check_circle' : 'timer'))])]
        }
      }], null, true)
    }, [_c('small', [_vm._v(_vm._s(item.emailConfirmado && item.fechaCuentaActivada ? 'Verificado' : 'No verificado'))])])], 1)], 1)], 1)
  }), 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "680",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsAccountsList()
      }
    },
    model: {
      value: (_vm.isAccountsList),
      callback: function($$v) {
        _vm.isAccountsList = $$v
      },
      expression: "isAccountsList"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex mx-4"
  }, [_c('h1', {
    staticClass: "text-left font-weight-700 font-size-15 py-2 mb-4"
  }, [_vm._v("Listado de cuentas relacionadas")]), _c('v-spacer')], 1), _c('v-card-text', [(_vm.isLoadingGetAccounts) ? _c('span', [_vm._v("cargando...")]) : _vm._e(), (_vm.selected && !_vm.isLoadingGetAccounts) ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('usuario-seleccionar', {
    ref: "lista_usuarios_manager",
    attrs: {
      "perfiles": [_vm.selected.perfil],
      "multiple": "multiple",
      "username": _vm.usuariosRelacionados,
      "no-solo": false
    },
    on: {
      "user-selected": _vm.obtenerUsuarioSeleccionado
    }
  })], 1) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsAccountsList()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCuentas()
      }
    }
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    },
    model: {
      value: (_vm.isActiveAccount),
      callback: function($$v) {
        _vm.isActiveAccount = $$v
      },
      expression: "isActiveAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v("Activar cuenta")]), _c('v-card-text', [_c('span', [_vm._v("Verifica los datos y presiona confirmar si deseas activar la siguiente cuenta de Help Desk.")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.selected ? _vm.selected.razonSocial : null))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveManagerAccount()
      }
    },
    model: {
      value: (_vm.isActiveManagerAccount),
      callback: function($$v) {
        _vm.isActiveManagerAccount = $$v
      },
      expression: "isActiveManagerAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v(_vm._s(_vm.isManagerAccount ? 'Activar permisos de administrador' : 'Desactivar permisos de administrador'))]), _c('v-card-text', [_c('span', [_vm._v("Al activar esta opcion la cuenta podra tener visibilidad de los usuarios que tengan relacion con")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.selected ? _vm.selected.razonSocial : null))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveManagerAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateManagerAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), (!_vm.selected) ? _c('v-card', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6 elevation-0",
    attrs: {
      "height": "calc(100vh - 68px)"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("person_search")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No se selecciono un usuario")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Seleccione un usuario en el panel isquierdo")])], 1) : _vm._e(), (_vm.selected) ? _c('div', {
    staticClass: "d-flex fd-column",
    class: {
      'border-radius-none': _vm.isMovil
    },
    attrs: {
      "color": "white"
    }
  }, [(_vm.perfilUsuario !== 'sistemas') ? _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('div', {
    staticClass: "position-relative"
  }, [_c('v-avatar', {
    staticClass: "elevation-1",
    attrs: {
      "size": 50
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "path": _vm.selected.foto,
      "gradient": "gradient"
    }
  })], 1)], 1), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "font-weight-700 mr-2 font-size-17"
  }, [_vm._v(_vm._s(_vm.selected.nombre))]), ((_vm.selected.fechaCuentaActivada && _vm.selected.perfil === 'usuario-contrato') || (_vm.selected.emailConfirmado && _vm.selected.perfil === 'usuario')) ? _c('v-chip', {
    staticClass: "font-weight-700 elevation-1",
    attrs: {
      "color": "success"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "15"
    }
  }, [_vm._v("check")]), _c('span', [_vm._v("Activo")])], 1) : _c('v-chip', {
    staticClass: "font-weight-700 elevation-1",
    attrs: {
      "color": "warning"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "15"
    }
  }, [_vm._v("timer")]), _c('span', [_vm._v("Pendiente")])], 1)], 1)]), _c('v-list-item-subtitle', {
    class: _vm.isMovil ? 'font-size-12' : 'font-size-12'
  }, [_c('span', [_vm._v(_vm._s(_vm.selected.cargo))]), (_vm.perfilUsuario !== 'usuario-contrato') ? _c('span', [_vm._v("  (" + _vm._s(_vm.selected.tipoArea) + "/" + _vm._s(_vm.selected.zonaGarantia) + ")")]) : _vm._e()])], 1), _c('v-list-item-action', [_c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "icon": "icon",
            "disabled": _vm.perfilUsuario === 'supervisor'
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1)]
      }
    }], null, false, 4094011321)
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.enviarDatosDelUsuario()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Enviar datos del usuario al SIV")])], 1)], 1)], 1)], 1)], 1), ((_vm.perfilUsuario === 'dispatcher' || _vm.perfilUsuario === 'supervisor' || _vm.perfilUsuario === 'sistemas') && _vm.selected && _vm.selected.perfil === 'usuario-contrato' && _vm.selected.emailConfirmado && !_vm.selected.fechaCuentaActivada) ? _c('v-alert', {
    staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
    attrs: {
      "dense": "dense",
      "border": "left",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Esta cuenta esta pendiente de activación.")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "white warning--text"
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsActiveAccount()
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _c('small', {
    staticClass: "is-bold"
  }, [_vm._v("Activar")])], 1)], 1)]) : _vm._e()], 1) : _vm._e(), (_vm.selected && _vm.selected.fechaCuentaActivada) ? _c('v-list', {
    staticClass: "px-4 py-0"
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("person")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v("Otorgar permisos para manejar otras cuentas")])]), _c('v-list-item-subtitle', [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Visibilidad de todas las acciones de cuentas relacionados.")])])], 1), _c('v-list-item-action', [_c('div', {
    staticClass: "d-flex ai-center jc-center"
  }, [(_vm.selected.esCuentaAdministrador) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "info",
      "loading": _vm.isLoadingActivating,
      "small": "small",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsAccountsList()
      }
    }
  }, [_c('small', [_vm._v("Administrar cuentas")])]) : _vm._e(), _c('v-switch', {
    attrs: {
      "dense": "dense"
    },
    on: {
      "change": function($event) {
        return _vm.openModalIsActiveManagerAccount()
      }
    },
    model: {
      value: (_vm.isManagerAccount),
      callback: function($$v) {
        _vm.isManagerAccount = $$v
      },
      expression: "isManagerAccount"
    }
  })], 1)])], 1)], 1) : _vm._e(), (_vm.isRenderComponent && _vm.selected.usuario && _vm.perfilUsuario !== 'sistemas') ? _c('item-usuario', {
    attrs: {
      "datos": _vm.selected,
      "show-details": "show-details"
    }
  }) : (_vm.isRenderComponent && _vm.selected.usuario && _vm.perfilUsuario === 'sistemas') ? _c('form-editar-usuario', {
    attrs: {
      "username": _vm.selected.usuario,
      "validar": _vm.perfilUsuario !== 'sistemas'
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b9885e7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_administrador_usuarios.vue
// module id = 505
// module chunks = 1